import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import { requestDetail } from 'routes/AppUrls';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getRequestListData } from 'store/requestList/requestListAction';
import moment from 'moment';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import CheckPromote from 'assets/images/Dashboard/check.svg';
import CrossIcon from 'assets/images/Dashboard/cross.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import ReusablePagination from 'components/commom/Pagination';
import {
  basicDetailsValue,
  REQUEST_ID,
  REQUEST_VALUE,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import CommonToast from 'components/commom/CommonToast';

const NewRequestList = ({ tab }) => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [newList, setNewList] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const itemsPerPage = 10;

  const loading = useSelector(
    (state) => state?.requestListDataReducer?.loading
  );

  useEffect(() => {
    getRequestData();
  }, []);

  const getRequestData = (pageValue) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setNewList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getRequestListData(external, tab, pageValue));
  };

  const handleNavigateDetail = (id) => {
    navigate(requestDetail(locale));
    dispatch(basicDetailsValue(REQUEST_ID, id));
    dispatch(basicDetailsValue(REQUEST_VALUE, 'request'));
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getRequestData(value);
  };

  return (
    <div className="pt-20">
      {loading ? (
        <Loader />
      ) : newList && newList.length > 0 ? (
        <>
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Provider & ID" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Contact Info" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Requested on" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Promoted" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Actions" />
              </p>
            </Col>
          </Row>
          <Row className="bc-FFFFFF m-0 p-0">
            {newList.map((item, index) => {
              return (
                <Row className="m-0 p-0 flex items-center listAppointment">
                  <Col lg={3} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                      {item?.provider_name}
                    </div>
                    <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                      {`${item?.provider_city}, ${item?.provider_state}`}
                    </div>
                  </Col>
                  <Col lg={3} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center "
                    >
                      <Image src={mail} alt="icon" />
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                        {item?.provider_email}
                      </div>
                    </Stack>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center pt-04"
                    >
                      <img src={call} alt="icon" />
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                        {item?.provider_country_code} {item?.provider_phone}
                      </div>
                    </Stack>
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                      {moment(item?.requested_on).format('DD MMM YYYY')}
                    </div>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    {item?.is_promoted === true ? (
                      <Image src={CheckPromote} alt="icon" />
                    ) : (
                      <Image src={CrossIcon} alt="icon" />
                    )}
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <Stack
                      direction="horizontal"
                      gap={1}
                      className="items-center cursor-pointer"
                      onClick={() => handleNavigateDetail(item?.id)}
                    >
                      <div className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4">
                        <FormattedMessage id="View Details" />
                      </div>
                      <Image src={ArrowRightIcon} alt="icon" />
                    </Stack>
                  </Col>
                </Row>
              );
            })}
          </Row>
        </>
      ) : (
        <div className="flex justify-center pt-120">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
              Nothing here yet
            </div>
          </div>
        </div>
      )}
      <Row>
        {count > 1 && (
          <Col sm={12} className="flex justify-end p-0">
            <div className="pt-16">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default NewRequestList;
